export function getOrganizationSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "韩漫之家",
    "url": "http://informyi.com/",
    "description": "韩漫之家是国内领先的韩国漫画免费阅读平台，提供韩漫在线和韩漫大全服务，让您轻松访问海量韩国漫画资源。",
    "sameAs": [],
  };
}

export function getWebSiteSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "韩漫之家",
    "url": "http://informyi.com/",
    "description": "韩国漫画免费阅读平台 - 韩漫在线、韩漫大全",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "http://informyi.com/search?q={search_term_string}",
      "query-input": "required name=search_term_string",
    },
    "inLanguage": "zh-CN",
  };
}

export function getWebPageSchema({
  title,
  description,
  url,
  datePublished,
  dateModified,
}: {
  title: string;
  description: string;
  url: string;
  datePublished?: string;
  dateModified?: string;
}) {
  return {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": title,
    "description": description,
    "url": url,
    "datePublished": datePublished || "2026-01-01",
    "dateModified": dateModified || "2026-07-03",
    "inLanguage": "zh-CN",
    "isPartOf": {
      "@type": "WebSite",
      "name": "韩漫之家",
      "url": "http://informyi.com/",
    },
  };
}

export function getBreadcrumbSchema(items: { name: string; url: string }[]) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": item.url,
    })),
  };
}

export function getArticleSchema({
  title,
  description,
  url,
  imageUrl,
  author,
  datePublished,
  dateModified,
}: {
  title: string;
  description: string;
  url: string;
  imageUrl: string;
  author: string;
  datePublished?: string;
  dateModified?: string;
}) {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": title,
    "description": description,
    "image": imageUrl,
    "url": url,
    "author": {
      "@type": "Person",
      "name": author,
    },
    "publisher": {
      "@type": "Organization",
      "name": "韩漫之家",
    },
    "datePublished": datePublished || "2026-01-01",
    "dateModified": dateModified || "2026-07-03",
    "inLanguage": "zh-CN",
  };
}

export function getFAQSchema(faqs: { question: string; answer: string }[]) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map((faq) => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer,
      },
    })),
  };
}